// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetWebMembersOperationByIdRequestModel from '../../model/get-web-members-operation-by-id-request-model';
import GetWebMembersOperationByIdRequestDTO from '../dto/get-web-members-operation-by-id-request-dto';
import dtoSchema from '../schemas/get-web-members-operation-by-id-request-schema';

export default abstract class GetWebMembersOperationByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetWebMembersOperationByIdRequestDTO>) {
    super();
    if (data) {
      this.organisationId = data.organisationId;
      this.operationId = data.operationId;
    }
  }
  /**
  * @type {uuid}
  */
  organisationId?: string;
  /**
  * @type {uuid}
  */
  operationId?: string;

  static toModel(dto: DeepPartial<GetWebMembersOperationByIdRequestDTO>): GetWebMembersOperationByIdRequestModel;
  static toModel(dto: DeepPartial<GetWebMembersOperationByIdRequestDTO> | undefined | null): GetWebMembersOperationByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetWebMembersOperationByIdRequestDTO> | undefined | null): GetWebMembersOperationByIdRequestModel | undefined {
    return dto ? new GetWebMembersOperationByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetWebMembersOperationByIdRequestModel> | GetWebMembersOperationByIdRequestModel): GetWebMembersOperationByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      organisationId: unwrapped.organisationId,
      operationId: unwrapped.operationId,
    } as GetWebMembersOperationByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetWebMembersOperationByIdRequestModel, can not map to GetWebMembersOperationByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
